import { VoidFunctionComponent, useCallback } from 'react';
import { Connector, useConnect, useDisconnect } from 'wagmi';
import { useKeyPressEvent } from 'react-use';
import { PlaystationButton } from '@/components/PlaystationButton';
import { chainId } from '@/lib/globals';

const isMobileDevice = 'ontouchstart' in window || 'onmsgesturechange' in window;

interface Props {
    connector: Connector;
    goToNextScene: () => void;
    fontSize?: number;
}

export const ConnectorButton: VoidFunctionComponent<Props> = ({ connector, goToNextScene, fontSize }) => {
    const { connectAsync } = useConnect();
    const { disconnectAsync } = useDisconnect();

    const metaMaskConnector = connector.id === 'injected';
    const nonMetamaskBrowser = !window.ethereum?.isMetaMask;
    const changeLocationOnClick = isMobileDevice && metaMaskConnector && nonMetamaskBrowser;

    const activate = useCallback(async (): Promise<void> => {
        await disconnectAsync();
        await connectAsync({ connector, chainId });
        goToNextScene();
    }, [disconnectAsync, connectAsync, connector, goToNextScene]);

    const selectProvider = useCallback(() => {
        if (changeLocationOnClick) {
            window.location.href = `https://metamask.app.link/dapp/${window.location.host}/connect`;
        }

        void activate();
    }, [changeLocationOnClick, activate]);

    useKeyPressEvent(metaMaskConnector ? 'a' : 'b', selectProvider);

    return (
        <PlaystationButton
            fontSize={fontSize}
            clickableAreaDimensions={[3.2, 0.7]}
            action={selectProvider}
            icon={metaMaskConnector ? 'square' : 'triangle'}
            label={metaMaskConnector ? 'MetaMask' : connector.name}
        />
    );
};
